import React from "react";
import { Box } from "@mui/material";
import * as mui from "tss-react/mui";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { StyledTooltip } from "../tooltip/Tooltip.js";
import "moment-timezone";
import "react-intl";
import "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import "../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
const useClasses = mui.makeStyles()((theme) => ({
  infoMessageIcon: {
    fontSize: theme.typography.body2.fontSize
  },
  infoMessageContainer: {
    display: "flex",
    columnGap: theme.spacing(1),
    alignItems: "center",
    overflow: "hidden"
  },
  infoMessage: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%"
  }
}));
const withInfoMessage = (WrappedComponent) => ({ infoMessage, showInfoMessage, ...props }) => {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.infoMessageContainer }, infoMessage && showInfoMessage ? /* @__PURE__ */ React.createElement(
    StyledTooltip,
    {
      element: /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(Icon, { color: IconColor.Secondary, icon: CustomIcon.WarningOutline, className: classes.infoMessageIcon })),
      title: /* @__PURE__ */ React.createElement(Box, null, infoMessage)
    }
  ) : null, /* @__PURE__ */ React.createElement(Box, { className: classes.infoMessage }, /* @__PURE__ */ React.createElement(WrappedComponent, { ...props })));
};
export {
  useClasses,
  withInfoMessage
};
//# sourceMappingURL=InfoMessageHoc.js.map
